<template>
  <div>
    <hr class="emd-divider" />
    <div class="eu-pa_3 eu-pa_5_md eu-flex">
        <span class="summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_2">{{ $t('paymentMethods') }}</span>
        <span class="summary-content eu-flex-item eu-basis_12 eu-basis_12_md eu-py_1_md" v-if="paymentMethods.credit_card_enabled">
          {{ $t('creditCard') }} ({{ $t('in', { installment: creditCardSettings.max_installments }) }})
        </span>
        <span class="summary-content eu-flex-item eu-basis_12 eu-basis_12_md eu-py_1_md" v-if="paymentMethods.boleto_enabled">
          {{ $t('boleto') }}
        </span>
        <span class="summary-content eu-flex-item eu-basis_12 eu-basis_12_md eu-py_1_md" v-if="paymentMethods.pix_enabled">
          {{ $t('pix') }}
        </span>
        <span class="summary-content eu-flex-item eu-basis_12 eu-basis_12_md eu-py_1_md" v-if="noPaymentMethods">
          -
        </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Payment',
  computed: {
    ...mapGetters(['paymentMethods', 'creditCardSettings']),
    noPaymentMethods () {
      return Object.values(this.paymentMethods).every(paymentMethod => {
        if (!paymentMethod) {
          return true
        }
        return false
      })
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "paymentMethods": "Formas de pagamento",
    "creditCard": "Cartão de crédito",
    "boleto": "Boleto",
    "pix": "Pix",
    "in": "em até {installment}x"
  },
  "en-US": {
    "paymentMethods": "Payment methods",
    "creditCard": "Credit card",
    "boleto": "Boleto",
    "pix": "Pix",
    "in": "in {installment}x"
  }
}
</i18n>
